<div class="edit-page-root-container settings-edit-root-container">
    <div class="page-content">
        <div class="page-header">
            <button mat-button class="nav-button" (click)="navBack()">
                <mat-icon>arrow_back</mat-icon>
            </button>
            <div class="title">
                {{title}}
            </div>
            <div class="action-btn-container">
                <button mat-flat-button class="action-btn btn-discard" (click)="navBack()">DISCARD</button>
                <button mat-flat-button class="action-btn btn-save" (click)="save()">SAVE</button>
            </div>
        </div>
        <div class="page-details">
            <form class="edit-form" [formGroup]="editForm">
                <div class="detail-section">
                    <div class="content-container">
                        <h2 class="section-title">Roster Block Colors</h2>
                        
                        <div class="input-group">
                            <div class="input-box-left">
                                <mat-form-field>
                                    <mat-label>Unavailable Background Color</mat-label>
                                    <input matInput type="color" formControlName="unavilable_bg_color" style="height: 30px; padding: 0;">
                                </mat-form-field>
                            </div>
                            
                            <div class="input-box-right">
                                <mat-form-field>
                                    <mat-label>Leave Background Color</mat-label>
                                    <input matInput type="color" formControlName="leave_bg_color" style="height: 30px; padding: 0;">
                                </mat-form-field>
                            </div>
                        </div>

                        <div class="input-group">
                            <div class="input-box-left">
                                <mat-form-field>
                                    <mat-label>Rostered Hour Color</mat-label>
                                    <input matInput type="color" formControlName="rostered_hour_color" style="height: 30px; padding: 0;">
                                </mat-form-field>
                            </div>
                            
                            <div class="input-box-right">
                                <mat-form-field>
                                    <mat-label>Actual Hour Color</mat-label>
                                    <input matInput type="color" formControlName="actual_hour_color" style="height: 30px; padding: 0;">
                                </mat-form-field>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="detail-section" style="margin-top: 24px;">
                    <div class="content-container">
                        <h2 class="section-title">Attendance Thresholds (Minutes)</h2>
                        
                        <div class="input-group">
                            <div class="input-box-left">
                                <mat-form-field>
                                    <mat-label>Before Start Time Threshold</mat-label>
                                    <input matInput type="number" formControlName="att_threshold_in_before">
                                </mat-form-field>
                            </div>
                            
                            <div class="input-box-right">
                                <mat-form-field>
                                    <mat-label>After Start Time Threshold</mat-label>
                                    <input matInput type="number" formControlName="att_threshold_in_after">
                                </mat-form-field>
                            </div>
                        </div>

                        <div class="input-group">
                            <div class="input-box-left">
                                <mat-form-field>
                                    <mat-label>Before Finish Time Threshold</mat-label>
                                    <input matInput type="number" formControlName="att_threshold_out_before">
                                </mat-form-field>
                            </div>
                            
                            <div class="input-box-right">
                                <mat-form-field>
                                    <mat-label>After Finish Time Threshold</mat-label>
                                    <input matInput type="number" formControlName="att_threshold_out_after">
                                </mat-form-field>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>
